import { Stack, Flex, Text, Box } from '@chakra-ui/core'
import { PopFormValues, PopType } from 'components/PopCreation/types'
import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { BodyField } from '../fileds/BodyField'
import { BtnTextField } from '../fileds/BtnTextField'
import { PopSwitch } from '../fileds/PopSwitch'
import { PushMessageField } from '../fileds/PushMessageField'
import { PushTitleField } from '../fileds/PushTitleField'
import { TitleField } from '../fileds/TitleField'
import { UploadMediaSection } from '../fileds/UploadMediaSection'
import useLocaleText from 'components/useLocaleText'
import { PopRecipients } from '../fileds/PopRecipients'

export const FakeRePop = () => {
  const { control } = useFormContext<PopFormValues>()
  const pick_audience = useLocaleText('pick_audience')
  const enable_push_notification = useLocaleText('enable_push_notification', true)

  return (
    <Stack style={{ gap: '15px' }}>
      <Stack style={{ gap: '10px' }} mt={4}>
        <TitleField />
        <BodyField keyName="data.pop_body" label="pop_body" placeholder="pop_body_placeholder" />
        <BtnTextField keyName="data.ack_btn_text" label="ack_btn" placeholder="ack_btn_placeholder" />
      </Stack>

      <Box>
        <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2}>
          {pick_audience}
        </Text>
        <PopRecipients />

        <Flex
          alignItems="center"
          flexDir={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
          w="100%"
          mt={2}
          style={{ gap: '10px' }}
        >
          <Box w="100%" h="97px">
            <BtnTextField
              keyName="data.repop_main_btn"
              label="repop_main_btn"
              placeholder="repop_main_btn_placeholder"
            />
          </Box>
          <Box w="100%" h="97px">
            <BtnTextField keyName="data.repop_sec_btn" label="repop_sec_btn" placeholder="repop_sec_btn_placeholder" />
          </Box>
        </Flex>
      </Box>

      <UploadMediaSection />

      <Flex flexDir="column" w={{ base: '100%', md: 'calc(50% - 10px)' }}>
        <Flex alignItems="center" justifyContent="space-between" w="100%">
          <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2} w="100%">
            {enable_push_notification}
          </Text>
          <PopSwitch name="data.is_repop_send_push_notification" />
        </Flex>

        <Box>
          <PushTitleField
            keyName="data.repop_push_title"
            label="repop_push_title"
            placeholder="repop_push_title_placeholder"
            keySwitch="data.is_repop_send_push_notification"
          />
          <PushMessageField
            keyName="data.repop_push_body"
            label="repop_push_body"
            placeholder="repop_push_body_placeholder"
            keySwitch="data.is_repop_send_push_notification"
          />
        </Box>
      </Flex>

      <Controller name="pop_type" control={control} defaultValue={PopType.FakeRe} as={<Box display="none" />} />
      <Controller name="rid" control={control} as={<Box display="none" />} />
    </Stack>
  )
}
